import axios from "@/lib/axios";

const getFacilityLens = () => {
  return axios.get("/facility/orders/facility_lens");
}

export default getFacilityLens;